<template>
  <div class="automacao-wizard__passo">
    <div
      class="automacao-wizard__card"
      :class="[
        'automacao-wizard__card--' + passo.tipo_no,
        { 'is-selecionado': selecionado, 'is-invalido': avisos.length },
      ]"
    >
      <div class="automacao-wizard__card-linha">
        <button type="button" class="automacao-wizard__card-botao" @click="$emit('selecionar', passo.id)">
          <span class="automacao-wizard__card-icone" aria-hidden="true">
            <i :class="icone"></i>
          </span>
          <span class="automacao-wizard__card-texto">
            <small>{{ rotulo.titulo }}</small>
            <strong>{{ rotulo.texto }}</strong>
          </span>
        </button>
        <button
          type="button"
          class="automacao-wizard__card-remover"
          title="Remover passo"
          @click.stop="$emit('remover', passo.id)"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div v-if="!passo.repetido && passo.tipo_no === 'condicao'" class="automacao-wizard__ramos">
      <div class="automacao-wizard__ramo automacao-wizard__ramo--sim">
        <span class="automacao-wizard__ramo-titulo">Sim</span>
        <automacao-wizard-passo
          v-for="filho in passo.sim"
          :key="'sim-' + filho.id"
          :passo="filho"
          :selecionado-id="selecionadoId"
          :erros-por-no="errosPorNo"
          @selecionar="$emit('selecionar', $event)"
          @adicionar="$emit('adicionar', $event)"
          @remover="$emit('remover', $event)"
        />
        <automacao-wizard-add
          v-if="!passo.sim.length"
          pergunta="O que fazer no sim?"
          @adicionar="$emit('adicionar', { tipo: $event, paiId: passo.id, saida: 'output_1' })"
          @pular="simPulado = true"
        />
      </div>
      <div v-if="mostrarNao" class="automacao-wizard__ramo automacao-wizard__ramo--nao">
        <span class="automacao-wizard__ramo-titulo">Não</span>
        <automacao-wizard-passo
          v-for="filho in passo.nao"
          :key="'nao-' + filho.id"
          :passo="filho"
          :selecionado-id="selecionadoId"
          :erros-por-no="errosPorNo"
          @selecionar="$emit('selecionar', $event)"
          @adicionar="$emit('adicionar', $event)"
          @remover="$emit('remover', $event)"
        />
        <automacao-wizard-add
          v-if="!passo.nao.length"
          pergunta="O que fazer no não?"
          @adicionar="$emit('adicionar', { tipo: $event, paiId: passo.id, saida: 'output_2' })"
        />
      </div>
    </div>

    <div v-else-if="!passo.repetido" class="automacao-wizard__proximo">
      <automacao-wizard-passo
        v-for="filho in passo.sim"
        :key="'sim-' + filho.id"
        :passo="filho"
        :selecionado-id="selecionadoId"
        :erros-por-no="errosPorNo"
        @selecionar="$emit('selecionar', $event)"
        @adicionar="$emit('adicionar', $event)"
        @remover="$emit('remover', $event)"
      />
      <automacao-wizard-add
        v-if="!passo.sim.length"
        pergunta="O que vem a seguir?"
        @adicionar="$emit('adicionar', { tipo: $event, paiId: passo.id, saida: 'output_1' })"
      />
    </div>
  </div>
</template>

<script>
import AutomacaoWizardAdd from './AutomacaoWizardAdd.vue'
import { iconeBloco, rotuloBloco } from './automacao-drawflow'

export default {
  name: 'AutomacaoWizardPasso',
  components: {
    AutomacaoWizardAdd,
  },
  props: {
    passo: {
      type: Object,
      required: true,
    },
    selecionadoId: {
      type: [String, Number],
      default: null,
    },
    errosPorNo: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      simPulado: false,
    }
  },
  computed: {
    selecionado() {
      return String(this.selecionadoId) === String(this.passo.id)
    },
    rotulo() {
      return rotuloBloco(this.passo.tipo)
    },
    icone() {
      return iconeBloco(this.passo.tipo)
    },
    mostrarNao() {
      return this.passo.sim.length > 0 || this.passo.nao.length > 0 || this.simPulado
    },
    avisos() {
      return this.errosPorNo[String(this.passo.id)] || []
    },
  },
}
</script>
